mutation Logout($username: String!) {
  logout(username: $username) {
    ok
  }
}
